<form [formGroup]="parteBForm">
    <div class="card marginCards">
        <div class="card-body">
            <div class="alternativeinRow gap150">
                <div class="inCol gap30">
                    <div class="inCol" style="gap: 0;">
                        <label class="text-bold" style="margin-bottom: 0.5rem;">Atto di morte *</label>
                        <label for>Numero</label>
                        <input type="text" class="form-control field-height" id="numeromorte"
                            formControlName="attoMorteNumero"
                            [ngClass]="{'border-danger': invalidBorder('attoMorteNumero')}" maxlength="25">
                    </div>
                    <div class="form-group field-16 marginCards">
                        <div class="inCol" style="gap: 5px 0;">
                            <label>Solo per i comuni che presentano una<br>suddivisione
                                del
                                territorio in circoscrizioni</label>
                            <label>Ufficio di stato civile</label>
                            <div class="inRow" style="gap: 0 15px; align-items: center;">
                                <label style="margin-bottom: 0;">Circoscrizione</label>
                                <input type="text" class="form-control field-height" id="circoscrizione"
                                    formControlName="circoscrizione"
                                    [ngClass]="{'border-danger': invalidBorder('circoscrizione')}"
                                    (input)="limitInput($event.target, 2)">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="inCol" style="gap: 50px 0;">
                    <div class="inCol" style=" gap: 15px 0;">
                        <div class="inRow" style=" gap: 0 15px;margin-top: 15px;">
                            <label style="margin-bottom: 0px;">Parte</label>
                            <div class="inRowDispositionRadio form-check-inline">
                                <label style="margin-bottom: 0px;">I</label>
                                <input type="radio" class="form-check-input" id="parte1" value="1"
                                    formControlName="parte1">
                            </div>
                            <div class="inRowDispositionRadio form-check-inline">
                                <label style="margin-bottom: 0px;">II</label>
                                <input type="radio" class="form-check-input" id="parte1" value="2"
                                    formControlName="parte1">
                            </div>
                        </div>
                        <div class="inRow" style="gap: 0 15px;">
                            <label style="margin-bottom: 0;">Serie</label>
                            <div class="inRowDispositionRadio form-check-inline">
                                <label style="margin-bottom: 0;">B</label>
                                <input type="radio" class="form-check-input" id="serie1" value="1"
                                    formControlName="serie1">
                            </div>
                            <div class="inRowDispositionRadio form-check-inline">
                                <label style="margin-bottom: 0;">C</label>
                                <input type="radio" class="form-check-input" id="serie1" value="2"
                                    formControlName="serie1">
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="inCol" style="gap: 0;" formGroupName="denominazione">
                            <label class="headerCustomTable"
                                style="border-top-left-radius: 8px;border-top-right-radius: 8px;margin-bottom: 0;">Denominazione
                                di comune e provincia*</label>
                            <input type="text" class="form-control contentCustomTableB" id="denominazioneComune"
                                formControlName="fkComuneDescr"
                                [ngClass]="{'border-danger': invalidBorderComune('fkComuneDescr', 'denominazione', 'fkComune')}"
                                [ngbTypeahead]="search"
                                style="border-top-left-radius: 0px;border-top-right-radius: 0px;border-bottom-left-radius: 0px;border-bottom-right-radius: 0px;height: 40px;">
                            <input type="text" class="form-control contentCustomTableB" id="denominazioneProvincia"
                                formControlName="provincia" readonly
                                style="border-top-left-radius: 0px;border-top-right-radius: 0px;height: 40px;"
                                [ngClass]="{'border-danger': invalidBorderGroup('provincia', 'denominazione')}">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card marginCards">
        <div class="card-body">
            <div class="inCol" style="margin-top: 20px;">
                <div class="inCol" style="align-items: start;gap: 45px 0;">
                    <div
                        style="display: flex; justify-content: flex-start; flex-wrap: wrap; flex-direction: row; width: 100%;">
                        <div class="inCol" style="gap: 5px 0; margin-right: 40px">
                            <label class="text-bold">1. Data di morte *</label>
                            <div class="group-inline" formGroupName="dataMorte">
                                <div class="form-group field-14">
                                    <label class="textCenter">Data</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control field-height-40" placeholder="yyyy-mm-dd"
                                            [minDate]="{year: 1900, month: 1, day: 1}"
                                            [maxDate]="{year: dataAttuale.getFullYear(), month: dataAttuale.getMonth() + 1, day: dataAttuale.getDate()}"
                                            name="dataMorte" ngbDatepicker #datamorte="ngbDatepicker"
                                            (dateSelect)="onDateSelect($event, 'dataMorte', 'data')"
                                            formControlName="data"
                                            [ngClass]="{'border-danger': invalidBorderGroup('data', 'dataMorte')}" />
                                        <button class="btn btn-secondary field-height-40" style="align-items: center;"
                                            (click)="datamorte.toggle()" type="button">
                                            <img src="../assets/icons/calendar_ko.png" class="img-responsive"
                                                style="width: 20px; height:20px">
                                        </button>
                                    </div>
                                </div>
                                <div class="form-group field-2" style="padding-right: 10px;">
                                    <label class="textCenter">Ora</label>
                                    <input type="number" (keydown)="onHourInput($event, 2)" min="0" max="23"
                                        class="form-control field-height-40" id="oraEvento"
                                        formControlName="dataMorteHh"
                                        [ngClass]="{'border-danger': invalidBorderGroup('dataMorteHh', 'dataMorte')}">
                                </div>
                                <div class="form-group field-2">
                                    <label class="textCenter">Minuti</label>
                                    <input type="number" (keydown)="onMinuteInput($event, 2)"
                                        class="form-control field-height-40" id="minutiEvento" min="0" max="59"
                                        formControlName="dataMorteMm"
                                        [ngClass]="{'border-danger': invalidBorderGroup('dataMorteMm', 'dataMorte')}">
                                </div>
                            </div>
                        </div>
                        <div class="inCol" style="gap: 5px 0;margin-right: 40px">
                            <label class="text-bold">2. Data di nascita *</label>
                            <div class="group-inline">
                                <div class="form-group field-14" style="margin-right: 20px;">
                                    <label class="textCenter">Data</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control field-height-40" placeholder="yyyy-mm-dd"
                                            [minDate]="{year: 1900, month: 1, day: 1}"
                                            [maxDate]="{year: dataAttuale.getFullYear(), month: dataAttuale.getMonth() + 1, day: dataAttuale.getDate()}"
                                            name="dataNascita" (dateSelect)="onDateNascita($event)" ngbDatepicker
                                            #datanascita="ngbDatepicker" formControlName="dataNascita"
                                            [ngClass]="{'border-danger': invalidBorder('dataNascita')}" />
                                        <button class="btn btn-secondary field-height-40" style="align-items: center;"
                                            (click)="datanascita.toggle()" type="button">
                                            <img src="../assets/icons/calendar_ko.png" class="img-responsive"
                                                style="width: 20px; height:20px">
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="inCol" style="gap: 10px 0;">
                            <label class="text-bold">3. Località di nascita *</label>
                            <div class="inCol" style="gap: 0;">
                                <label>Selezionare</label>
                                <select name="localitanascita" id="localitanascita"
                                    class="custom-select-250 field-height" (change)="showInputLocalita($event)"
                                    formControlName="fkLocalitaNascita"
                                    [ngClass]="{'border-red': invalidBorder('fkLocalitaNascita')}"
                                    [ngClass]="{'disabledSelect': disableSelect == true}">
                                    <option *ngFor="let lNascita of dizionarioLocalitaNascita"
                                        [value]="lNascita.codice">
                                        {{lNascita.descrizione}}
                                    </option>
                                </select>
                                <div class="inRow" style="gap: 0 15px;margin-top: 15px;"
                                    *ngIf="selectedOptionLocalita === '2' || parteBForm.get('fkLocalitaNascita')?.value === '2'"
                                    formGroupName="altroComuneNascita">
                                    <div class="inCol field-24" style="gap: 0;">
                                        <label>Comune *</label>
                                        <input type="text" class="form-control field-height" id="comuneNascita"
                                            formControlName="fkLocalitaComuneNascitaDescr" [ngbTypeahead]="search"
                                            [ngClass]="{'border-danger': invalidBorderComune('fkLocalitaComuneNascitaDescr', 'altroComuneNascita', 'fkLocalitaComuneNascita')}">
                                    </div>
                                    <div class="inCol field-10" style="gap: 0;">
                                        <label>Prov. *</label>
                                        <input type="text" class="form-control field-height" id="provinciaNascita"
                                            formControlName="provincia" readonly
                                            [ngClass]="{'border-danger': invalidBorderGroup('provincia', 'altroComuneNascita')}">
                                    </div>
                                </div>
                                <div class="inCol field-24" style="gap: 0; margin-top: 15px;"
                                    *ngIf="selectedOptionLocalita === '3' || parteBForm.get('fkLocalitaNascita')?.value === '3'">
                                    <label>Stato *</label>
                                    <input type="text" class="form-control field-height" id="statoEsteroNascita"
                                        formControlName="fkLocalitaStatoEsteroNascitaDescr" [ngbTypeahead]="search2"
                                        [ngClass]="{'border-danger': invalidBorder('fkLocalitaStatoEsteroNascitaDescr')}">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        style="display: flex; justify-content: flex-start; flex-wrap: wrap; flex-direction: row; width: 100%;">
                        <div class="inCol" style="gap: 10px 0;margin-right: 40px">
                            <label class="text-bold">4. Età compiuta *</label>
                            <div class="inCol field-6" style="gap: 0;">
                                <label>Anni</label>
                                <input type="number" (input)="limitInput($event.target, 3)"
                                    class="form-control field-height" id="etaCompiuta" formControlName="etaCompiuta"
                                    [ngClass]="{'border-danger': invalidBorder('etaCompiuta')}">
                            </div>
                        </div>
                        <div class="inCol" style="gap: 10px 0;margin-right: 40px">
                            <label class="text-bold">5. Stato civile *</label>
                            <div class="inCol" style="gap: 0;">
                                <label>Selezionare</label>
                                <select name="statocivile" id="statocivile" class="custom-select-400"
                                    (change)="showInputStatoCivile($event)" formControlName="fkStatoCivile"
                                    [ngClass]="{'border-red': invalidBorder('fkStatoCivile')}"
                                    [ngClass]="{'disabledSelect': disableSelect == true}">
                                    <option *ngFor="let sCivile of dizionarioStatoCivile" [value]="sCivile.codice">
                                        {{sCivile.descrizione}}
                                    </option>
                                </select>
                                <div class="inCol" style="gap: 15px 0;margin-top: 15px;"
                                    *ngIf="selectedOptionStatoCivile === '2' || selectedOptionStatoCivile === '5' || selectedOptionStatoCivile === '6'
                                    || parteBForm.get('fkStatoCivile')?.value === '2' || parteBForm.get('fkStatoCivile')?.value === '5' || parteBForm.get('fkStatoCivile')?.value === '6'"
                                    formGroupName="casiStatoCivile">
                                    <div class="inCol field-14" style="gap: 0;">
                                        <label>Anno di nascita del coniuge
                                            superstite *</label>
                                        <input type="number" class="form-control field-height"
                                            id="annoNascitaSuperstite" formControlName="annoNascitaConiuge"
                                            [ngClass]="{'border-danger': invalidBorderGroup('annoNascitaConiuge', 'casiStatoCivile')}"
                                            (keydown)="maxLengthInput($event, 4)">
                                    </div>
                                    <div class="inCol field-14" style="gap: 0;">
                                        <label>Anno di matrimonio o di unione
                                            civile *</label>
                                        <input type="number" class="form-control field-height" id="annoMatrimonio"
                                            formControlName="annoMatrimonioUnione"
                                            [ngClass]="{'border-danger': invalidBorderGroup('annoMatrimonioUnione', 'casiStatoCivile')}"
                                            (keydown)="maxLengthInput($event, 4)">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="inCol marginTop-30" style="gap: 10px 0;margin-right: 40px">
                            <label class="text-bold">6. Residenza *</label>
                            <div class="inCol" style="gap: 0;">
                                <label>Selezionare</label>
                                <select name="residenza" id="residenza" class="custom-select-250"
                                    (change)="showInputResidenza($event)" formControlName="fkLocalitaResidenza"
                                    [ngClass]="{'border-red': invalidBorder('fkLocalitaResidenza')}"
                                    [ngClass]="{'disabledSelect': disableSelect == true}">
                                    <option *ngFor="let lResidenza of dizionarioLocalitaResidenza"
                                        [value]="lResidenza.codice">
                                        {{lResidenza.descrizione}}
                                    </option>
                                </select>
                                <div class="inRow" style="gap: 0 15px;margin-top: 15px;"
                                    *ngIf="selectedOptionResidenza === '2' || parteBForm.get('fkLocalitaResidenza')?.value == '2'"
                                    formGroupName="altroComuneResidenza">
                                    <div class="inCol field-24" style="gap: 0;">
                                        <label>Comune *</label>
                                        <input type="text" class="form-control field-height" id="comuneResidenza"
                                            formControlName="fkComuneResidenzaDescr" [ngbTypeahead]="search"
                                            [ngClass]="{'border-danger': invalidBorderComune('fkComuneResidenzaDescr', 'altroComuneResidenza', 'fkComuneResidenza')}">
                                    </div>
                                    <div class="inCol field-10" style="gap: 0;">
                                        <label>Prov. *</label>
                                        <input type="text" class="form-control field-height" id="provinciaResidenza"
                                            formControlName="provincia" readonly
                                            [ngClass]="{'border-danger': invalidBorderGroup('provincia', 'altroComuneResidenza')}">
                                    </div>
                                </div>
                                <div class="inCol field-24" style="gap: 0; margin-top: 15px;"
                                    *ngIf="selectedOptionResidenza === '3' || parteBForm.get('fkLocalitaResidenza')?.value == '3'">
                                    <label>Stato *</label>
                                    <input type="text" class="form-control field-height" id="statoEsteroResidenza"
                                        formControlName="fkStatoResidenzaDescr" [ngbTypeahead]="search2"
                                        [ngClass]="{'border-danger': invalidBorder('fkStatoResidenzaDescr')}">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="inCol" style="align-items: start;gap: 35px 0;margin-top: 35px;">
                    <div
                        style="display: flex; justify-content: flex-start; flex-wrap: wrap; flex-direction: row; width: 100%;">

                        <div class="inCol" style="gap: 10px 0;margin-right: 40px">
                            <label class="text-bold">7. Grado di istruzione *</label>
                            <div class="inCol" style="gap: 0;">
                                <label>Selezionare</label>
                                <select name="gradoistruzione" id="gradoistruzione" class="custom-select-350"
                                    formControlName="fkGradoIstruzione"
                                    [ngClass]="{'border-red': invalidBorder('fkGradoIstruzione')}"
                                    [ngClass]="{'disabledSelect': disableSelect == true}">
                                    <option *ngFor="let gIstruzione of dizionarioGradoIstruzione"
                                        [value]="gIstruzione.codice">
                                        {{gIstruzione.descrizione}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group field-26 marginTop-30" style="margin-right: 40px">
                            <label class="text-bold">8. Professione *</label>
                            <div class="marginTop-42">
                                <input type="text" class="form-control field-height-40" name="professione"
                                    formControlName="professione"
                                    [ngClass]="{'border-danger': invalidBorder('professione')}">
                            </div>
                        </div>
                        <div class="inCol" style="gap: 10px 0;">
                            <label class="text-bold">9. Condizione professionale o non
                                professionale *</label>
                            <div class="inCol" style=" gap: 0;">
                                <label>Selezionare</label>
                                <select name="condizioneprofessionale" id="condizioneProfessionale"
                                    class="custom-select-400" formControlName="fkCondizioneProfessionale"
                                    [ngClass]="{'border-red': invalidBorder('fkCondizioneProfessionale')}"
                                    [ngClass]="{'disabledSelect': disableSelect == true}">
                                    <option *ngFor="let cProfessionale of dizionarioCondizioneProfessionale"
                                        [value]="cProfessionale.codice">
                                        {{cProfessionale.descrizione}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div
                        style="display: flex; justify-content: flex-start; flex-wrap: wrap; flex-direction: row; width: 100%;">

                        <div class="inCol" style="gap: 10px 0;margin-right: 40px">
                            <label class="text-bold">10. Posizione nella
                                professione *</label>
                            <div class="inCol" style=" gap: 0;">
                                <label>Selezionare</label>
                                <div class="inCol" style="gap: 15px 0;">
                                    <select name="posizioneprofessione" id="posizioneprofessione"
                                        class="custom-select-350" formControlName="fkPosizioneProfessione"
                                        [ngClass]="{'border-red': invalidBorder('fkPosizioneProfessione')}"
                                        [ngClass]="{'disabledSelect': disableSelect == true}">
                                        <option *ngFor="let pProfessione of dizionarioPosizioneProfessione"
                                            [value]="pProfessione.codice">
                                            {{pProfessione.descrizione}}
                                        </option>
                                    </select>
                                    <!-- <div class="inCol" style="gap: 0;margin-left: 15px;"
                        *ngIf="selectedOptionPosizioneProfessione == 'lavoratoriautonomi'">
                        <label>Selezionare</label>
                        <select name="lavoratoriautonomi" id="lavoratoriautonomi"
                            class="custom-select-400 field-height" formControlName="lavoratoriAutonomi"
                            [ngClass]="{'border-red': invalidBorder('lavoratoriAutonomi')}">
                            <option value=""></option>
                            <option value="imprenditorelibero">Imprenditore/imprenditrice o
                                libero
                                professionista</option>
                            <option value="propriocoaudivante">Lavoratore/lavoratrice in proprio
                                o
                                coaudivante</option>
                            <option value="altro">Altro</option>
                        </select>
                    </div>
                    <div class="inCol" style="gap: 0;margin-left: 15px;"
                        *ngIf="selectedOptionPosizioneProfessione == 'lavoratoridipendenti'">
                        <label>Selezionare</label>
                        <select name="lavoratoriautonomi" id="lavoratoriDipendenti"
                            class="custom-select-350 field-height" formControlName="lavoratoriDipendenti"
                            [ngClass]="{'border-red': invalidBorder('lavoratoriDipendenti')}">
                            <option value=""></option>
                            <option value="dirigente">Dirigente o direttivo</option>
                            <option value="impiegato">Impiegato/a o intermedio</option>
                            <option value="operaio">Operaio/a o assimilato</option>
                            <option value="altro">Altro</option>
                        </select>
                    </div> -->
                                </div>
                            </div>
                        </div>
                        <div class="inCol marginTop-30" style="gap: 10px 0;margin-right: 40px">
                            <label class="text-bold">11. Ramo di attività economica *</label>
                            <div class="inCol" style="gap: 0;">
                                <label>Selezionare</label>
                                <select name="ramoattivita" id="ramoattivita" class="custom-select-350"
                                    formControlName="fkRamoAttivitaEconomica"
                                    [ngClass]="{'border-red': invalidBorder('fkRamoAttivitaEconomica')}"
                                    [ngClass]="{'disabledSelect': disableSelect == true}">
                                    <option *ngFor="let rAttivita of dizionarioRamoAttivita" [value]="rAttivita.codice">
                                        {{rAttivita.descrizione}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="inCol marginTop-30" style="gap: 10px 0;">
                            <label class="text-bold">12. Cittadinanza *</label>
                            <div class="inCol" style="gap: 0;">
                                <label>Selezionare</label>
                                <div class="inCol" style="gap: 15px 0;">
                                    <select name="ramoattivita" id="ramoattivita" class="custom-select-250"
                                        formControlName="fkCittadinanza" (change)="showInputCittadinanza($event)"
                                        [ngClass]="{'border-red': invalidBorder('fkCittadinanza')}"
                                        [ngClass]="{'disabledSelect': disableSelect == true}">
                                        <option *ngFor="let cittadinanza of dizionarioCittadinanza"
                                            [value]="cittadinanza.codice">
                                            {{cittadinanza.descrizione}}
                                        </option>
                                    </select>
                                    <div class="inCol" style="gap: 0;margin-left: 15px;"
                                        *ngIf="selectedOptionCittadinanza == '3' || parteBForm.get('fkCittadinanza')?.value === '3'">
                                        <label>(specificare stato estero)</label>
                                        <input type="text" class="form-control field-height" id="CittadinanzaStatoStraniera"
                                            formControlName="fkCittadinanzaStatoStranieraDesc"
                                            [ngbTypeahead]="search2"
                                            [ngClass]="{'border-danger': invalidBorder('fkCittadinanzaStatoStranieraDesc')}">
                                    </div>
                                    <!-- <div class="inCol" style="gap: 0;margin-left: 15px;"
                        *ngIf="selectedOptionCittadinanza == '1'">
                        <label>Selezionare</label>
                        <select name="italiana" id="cittadinanzaItaliana" formControlName="cittadinanzaItaliana"
                        class="custom-select-250 field-height"
                        [ngClass]="{'border-red': invalidBorder('cittadinanzaItaliana')}">
                            <option value=""></option>
                            <option value="nascita">Per nascita</option>
                            <option value="acquisita">Acquisita</option>
                        </select>
                    </div>
                    -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card">
        <div class="card-body">
            <div class="inCol" style="gap: 10px 0;margin-top: 20px;">
                <label class="text-bold">Firma e recapiti dell'Ufficiale dello
                    Stato Civile</label>
                <div class="group-inline" formGroupName="firmaRecapitiUfficiale">
                    <div class="form-group field-28">
                        <label>Recapito *</label>
                        <input type="text" class="form-control field-height" id="recapito" formControlName="recapito"
                            [ngClass]="{'border-danger': invalidBorderGroup('recapito', 'firmaRecapitiUfficiale')}">
                    </div>
                    <div class="form-group field-28">
                        <label>Tel. *</label>
                        <input type="tel" (input)="limitInput($event.target, 20)" class="form-control field-height"
                            id="tel" formControlName="telefono"
                            [ngClass]="{'border-danger': invalidBorderGroup('telefono', 'firmaRecapitiUfficiale')}">
                    </div>
                    <div class="form-group field-38">
                        <label>E-mail *</label>
                        <input type="email" class="form-control field-height" id="email" formControlName="email"
                            [ngClass]="{'border-danger': invalidBorderGroup('email', 'firmaRecapitiUfficiale')}">
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>